import batidoSaludable from '@icons/BatidoSaludable.svg';
import bebidaGranizada from '@icons/BebidaGranizada.svg';
import productosErmita from '@icons/ProductosErmita.svg';
import CopaHelado from '@icons/CopaHelado.svg';
import pastel from '@icons/Pastel.svg';
import malteada from '@icons/Malteada.svg';
import jugoNatural from '@icons/JugoNatural.svg';

export const icons = {
    batidoSaludable,
    bebidaGranizada,
    productosErmita,
    CopaHelado,
    pastel,
    malteada,
    jugoNatural
};